import { render, staticRenderFns } from "./InstallationModal.vue?vue&type=template&id=154062a8&scoped=true"
import script from "./InstallationModal.vue?vue&type=script&lang=js"
export * from "./InstallationModal.vue?vue&type=script&lang=js"
import style0 from "./InstallationModal.vue?vue&type=style&index=0&id=154062a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154062a8",
  null
  
)

export default component.exports